/**
 * Unwrap backend API response envelope.
 * Backend wraps responses in { success: true, data: T } or { success: true, data: { items: T[], meta: {...} } }
 * This extracts the inner data.
 */
export function unwrapResponse<T>(response: { success: true; data: T } | T): T {
	if (response && typeof response === "object" && "success" in response && "data" in response) {
		return (response as { success: true; data: T }).data;
	}
	return response as T;
}
